enum Tabs {
  Home,
  Message,
  Gigs,
  Profile,
  Search,
  Finance,
}

export default Tabs;
